import makesReducer from './makes';
import modelsReducer from './models';
import volumesReducer from './volumes';
import regionsReducer from './regions';
import fueltypesReducer from './fueltypes';
import logReducer from './log';
import { combineReducers } from 'redux';

const allReducers = combineReducers({
    makes: makesReducer,
    models: modelsReducer,
    volumes: volumesReducer,
    regions: regionsReducer,
    fueltypes: fueltypesReducer,
    log: logReducer
});

export default allReducers;